'use client';

import { SaleApplicationForm } from '../sale-application-form';
import { SaleApplicationSuccess } from '../SaleApplicationSuccess';
import { SaleBenefitsHeader } from '../sale-benefits-header';
import type { SellerProfileResponse } from '@/features/original-sale/types/sale.types';

interface SaleApplicationStagesProps {
  fanficId?: string;
  profile?: SellerProfileResponse | null;
  isSubmitted: boolean;
  onSuccess: () => void;
}

export const SaleApplicationStages = ({
  fanficId,
  profile,
  isSubmitted,
  onSuccess,
}: SaleApplicationStagesProps) => {
  const applicationStage = profile?.applicationStage;

  if (isSubmitted || (applicationStage === 2 && profile?.status === 'new')) {
    return (
      <div className="max-w-[620px] mx-auto py-6 space-y-10">
        <SaleApplicationSuccess />
      </div>
    );
  }

  return (
    <div className="max-w-[620px] mx-auto py-6 space-y-10">
      <SaleBenefitsHeader />
      <SaleApplicationForm fanficId={fanficId} profile={profile} onSuccess={onSuccess} />
    </div>
  );
};
